// NOTE: IF THOSE VALUES CHANGE, WE SHOULD CHANGE IT IN OUR AUTH REPO
export const REFRESH_TOKEN_COOKIE_NAME = 'rt';
export const ACCESS_TOKEN_COOKIE_NAME = 'at';
export const ACCESS_TOKEN_EXPIRATION_COOKIE_NAME = 'atexp';
export const USER_ID = 'id';
export const DEFAULT_PHOTO_URL = `https://www.gravatar.com/avatar/00000000000000000000000000000000?d=mp&f=y`;

export const AUTH_ONBOARDING_ANNOUNCEMENT_TYPE = 'auth-onboarding';
